import { useI18n } from "@/lib/i18n";
import { useParametres } from "@/hooks/useParametres";
import { useSeo } from "@/hooks/useSeo";
import { truncate } from "@/lib/seo";

function Terms() {
  const { t } = useI18n();
  const { data: parametres } = useParametres();
  const titre = parametres?.["pages.terms.titre"];
  const corps = parametres?.["pages.terms.corps"];

  useSeo({
    title: `${titre || t("terms.heading")} — Ramba News`,
    description: truncate(corps || t("terms.body")),
    path: "/terms",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-14">
      <h1 className="font-serif text-3xl md:text-4xl font-semibold tracking-tight">{titre || t("terms.heading")}</h1>
      <p className="mt-4 text-muted-foreground leading-relaxed whitespace-pre-wrap">{corps || t("terms.body")}</p>
    </div>
  );
}

export default Terms;
